module.exports = "<div class=\"login__header\">\n  <h2 class=\"login__main-title\" translate>login.register.title.main</h2>\n</div>\n<div class=\"login__content\">\n  <p class=\"login__text\">{{'login.register.text' + $ctrl.countryCode | translate}}</p>\n</div>\n<div class=\"login__footer\">\n  <button class=\"js-return-login button-primary fullWidth\" ng-click=\"$ctrl.onReturnLogin()\" translate>login.signin</button>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login-dialog/register/register.html
// module id = 291
// module chunks = 0